import { Injectable } from '@angular/core';
import { Worktypes } from '@models/worktypes.model';
import BaseService from './base.service';

@Injectable({
  providedIn: 'root'
})
export class WorktypeService extends BaseService<Worktypes> {}